export const RECENT_PRESCRIPTIONS_DEFAULT_SORT = 'createdAt:DESC';
export const RECENT_PRESCRIPTIONS_LIMIT = 10;
